import Vue from 'vue'
import App from './account.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#account',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/account/account.js